import Vue from 'vue';
import Router from 'vue-router';

import RouteView from '../components/route-view.vue';

import Login from '../components/login/login.vue';
import Home from '../components/home/home.vue';
import Orders from '../components/orders/orders.vue';
import Workplace from '../components/welcome';
import Rolemanager from '../components/rolemanager/index.vue';
import accountmanager from '../components/accountmanager/index.vue';
import MenuManage from '../components/menumanage/index.vue';
import Clientmanage from '../components/clientmanage/index.vue';
import merchantdetails from '../components/clientmanage/merchantdetails.vue';
import walletRecord from '../components/walletRecord/index.vue';
import merchantIp from '../components/merchantIp/index.vue';
import merchantInfo from '../components/merchantInfo';
import transactionRecord from '../components/transactionRecord/index.vue';
import withdrawBank from '../components/withdrawBank/index.vue';
import withdraw from '../components/withdraw/index.vue';
import merchantdeposit from '../components/merchantdeposit/index.vue';
import merchantAmount from '../components/merchant-amount';
import userTransaction from '../components/userTransaction/index.vue';
import transaction from '../components/transaction/index.vue';
import channelConf from '@/components/channel-conf';
import merchantBalance from '@/components/merchant-balance';
import channelUser from '@/components/channel-user';
import channelUserMomo from '@/components/channel-user-momo';
import channelTest from '@/components/channel-test';
import momoLogs from '@/components/momo-logs';
import safeCenter from '@/components/safe-center';
import merchantBehalf from '../components/payout/orders';
import channelTypeManage from '../components/channeltypemanage';
import balanceHistory from '../components/balance-history';
import usdtAccount from '../components/usdt/account';
import usdtWithdrawList from '../components/usdt/withdrawlist';
import usdtOrderManage from '../components/usdt/index';
import usdtWithdrwa from '../components/usdt/withdrwa';
import userContacts from '../components/apply/index';
import momoDevices from '../components/device/momoDevices';
import paybank from '../components/device/paybank';
import paybankhistory from '../components/device/paybankhistory';
import viettelDevices from '../components/device/viettelDevices';
import zaloDevices from '../components/device/zaloDevices';
import momohistory from '../components/device/momohistory';
import zalohistory from '../components/device/zalohistory';
import viettelhistory from '../components/device/viettelhistory';
import bankwithdrawak from '../components/device/bankwithdrawak';
import zalowithdrawak from '../components/device/zalowithdrawak';
import momowithdrawak from '../components/device/momowithdrawak';
import viettelwithdrawak from '../components/device/viettelwithdrawak';
import autoOrders from '../components/payout/autoOrders/index.vue';
import manualOrders from '../components/payout/manualOrders/index.vue';


import bankconfirm from '../components/device/bankconfirm';
import subAccount from '../components/childrenlist/index.vue';

import systemConfig from '../components/systemConfig/index.vue';
import channelList from '../components/channelList/index.vue';
import ChannelSetting from '../components/channelSetting/index.vue';

import C404 from '@/components/404';
import Welcomes from '@/components/welcomes/index.vue';

class MyRouter extends Router {
  push(location) {
    console.log('🚀 ~ file: index.js ~ line 27 ~ MyRouter ~ push ~ location', location);
    return super.push.call(this, location).catch((err) => err);
  }
}
Vue.use(MyRouter);

// const RouteView = {
//   name: 'RouteView',
//   render: (h) => h('router-view')
// };

const asyncRouterMap = [
  {
    path: '/',
    name: 'home',
    component: Home,
    redirect: '/welcomes',
    children: [
      //没有权限时进入 welcomes页面
      {
        path: '/welcomes',
        name: 'welcomes',
        component: Welcomes,
        children: [
         
        ]
      },
      // welcome
      {
        path: '/dashboard',
        name: 'dashboard',
        redirect: '/dashboard/workplace',
        component: RouteView,
        meta: { permission: ['dashboard:manager'] },
        children: [
          {
            path: '/dashboard/workplace',
            name: 'Workplace',
            component: Workplace,
            meta: { permission: ['workplace:manager'] }
          }
        ]
      },
      // merchant
      {
        path: '/merchant',
        name: 'merchant',
        redirect: '/merchant/orders',
        component: RouteView,
        meta: { permission: ['merchant:manager'] },
        children: [
          {
            path: '/merchant/apply/list/page',
            name: 'userContactList',
            component: userContacts,
            meta: { permission: ['merchant:apply:list:page'] }
          },
          {
            path: '/merchant/clientmanage',
            name: 'Clientmanage',
            component: Clientmanage,
            meta: { permission: ['system:clientmanage'] }
          },
          {
            path: '/merchant/subAccount/list/page',
            name: 'subAccount',
            component: subAccount,
            meta: { permission: ['merchant:subAccount:list:page'] }
          },
          {
            path: '/merchant/merchantdetails',
            name: 'merchantdetails',
            component: merchantdetails,
            meta: {
              isHide: true
            }
          },
          {
            path: '/merchant/withdrawBank',
            name: 'withdrawBank',
            component: withdrawBank,
            meta: { permission: ['withdrawBank:manager'] }
          },
          {
            path: '/merchant/merchantInfo',
            name: 'merchantInfo',
            component: merchantInfo,
            meta: {
              permission: ['merchantInfo']
              //  isKeepAlive: true
            }
          },
          {
            path: '/merchant/safeCenter',
            name: 'safeCenter',
            component: safeCenter,
            meta: { permission: ['securitycenter'] }
          },
          {
            path: '/merchant/payout/orders',
            name: 'merchantBehalf',
            component: merchantBehalf,
            meta: { permission: ['merchant:payout:orders'] }
          },
          {
            path: '/merchant/payout/autoOrders',
            name: 'autoOrders',
            component: autoOrders,
            meta: { permission: ['merchant:payout:autoOrders'] }
          },
          {
            path: '/merchant/payout/manualOrders',
            name: 'manualOrders',
            component: manualOrders,
            meta: { permission: ['merchant:payout:manualOrders'] }
          },

          {
            path: '/merchant/withdraw',
            name: 'merchantWithdraw',
            component: withdraw,
            meta: { permission: ['withdraw:manager'] }
          },
          {
            path: '/merchant/merchantdeposit',
            name: 'merchantdeposit',
            component: merchantdeposit,
            meta: { permission: ['merchant:deposit'] }
          },

          {
            path: '/merchant/orders',
            name: 'Orders',
            component: Orders,
            meta: { permission: ['merchant:order'] }
          },
          {
            path: '/merchant/walletRecord',
            name: 'walletRecord',
            component: walletRecord,
            meta: { permission: ['system:walletRecord'] }
          },
          {
            path: '/merchant/balance/page',
            name: 'MerchantBalanceHis',
            component: balanceHistory,
            meta: { permission: ['merchant:balance:list'] }
          },
          {
            path: '/merchant/usdt/account/list/page',
            name: 'USDTAccount',
            component: usdtAccount,
            meta: { permission: ['merchant:usdt:account:list:page'] }
          },
          {
            path: '/merchant/usdt/withdraw/list',
            name: 'WithdrawList',
            component: usdtWithdrawList,
            meta: { permission: ['withdraw:usdt:list:page'] }
          },
          {
            path: '/merchant/usdt/list/page',
            name: 'USDTOrderManage',
            component: usdtOrderManage,
            meta: { permission: ['merchant:usdt:lis:page'] }
          },
          {
            path: '/merchant/usdt/withdraw',
            name: 'USDTWithdraw',
            component: usdtWithdrwa,
            meta: { permission: ['merchant:usdt:withdraw'] }
          }
        ]
      },
      //systemmanagement
      {
        path: '/systemmanagement',
        name: 'systemmanagement',
        component: RouteView,
        meta: { permission: ['system:manager'] },
        children: [
          {
            path: '/systemmanagement/userTransaction',
            name: 'userTransaction',
            component: userTransaction,
            meta: { permission: ['userTransaction:manager'] }
          },
          {
            path: '/systemmanagement/menumanage',
            name: 'menumanage',
            component: MenuManage,
            meta: { permission: ['menu:manager'] }
          },
          {
            path: '/systemmanagement/merchantAmount',
            name: 'merchantAmount',
            component: merchantAmount,
            meta: { permission: ['walletAmount:total'] }
          },
          {
            path: '/systemmanagement/rolemanager',
            name: 'rolemanager',
            component: Rolemanager,
            meta: { permission: ['role:manager'] }
          },
          {
            path: '/systemmanagement/merchantIp',
            name: 'merchantIp',
            component: merchantIp,
            meta: { permission: ['merchantIp:manager'] }
          },
          {
            path: '/systemmanagement/merchantPayoutIp',
            name: 'merchantPayoutIp',
            component: () => import('@/components/merchantPayoutIp/index.vue'),
            meta: { permission: ['merchantPayoutIp:manager'] }
          },
          {
            path: '/systemmanagement/transactionRecord',
            name: 'transactionRecord',
            component: transactionRecord,
            meta: { permission: ['transactionRecord:manager'] }
          },

          {
            path: '/systemmanagement/transaction',
            name: 'transaction',
            component: transaction,
            meta: { permission: ['transaction:manager'] }
          },
          {
            path: '/systemmanagement/channelConf',
            name: 'channelConf',
            component: channelConf,
            meta: { permission: ['channelConfig:management'] }
          },
          {
            path: '/channelType/page',
            name: 'channelType',
            component: channelTypeManage,
            meta: { permission: ['channel:type:list'] }
          },
          {
            path: '/systemmanagement/channelUser',
            name: 'channelUser',
            component: channelUser,
            meta: { permission: ['channel:management'] }
          },
          {
            path: '/systemmanagement/channelUserMomo',
            name: 'channelUserMomo',
            component: channelUserMomo,
            meta: { permission: ['channelUserMomo:management'] }
          },

          {
            path: '/systemmanagement/momoLogs',
            name: 'momoLogs',
            component: momoLogs,
            meta: {
              permission: ['momo:record']
            }
          },

          {
            path: '/systemmanagement/merchantBalance',
            name: 'merchantBalance',
            component: merchantBalance,
            meta: { permission: ['walletAmount:merchant'] }
          },
          {
            path: '/systemmanagement/channelTest',
            name: 'channelTest',
            component: channelTest,
            meta: { permission: ['test:payment'] }
          },
          {
            path: '/systemmanagement/accountmanager',
            name: 'accountmanager',
            component: accountmanager,
            meta: { permission: ['account:manager'] }
          },
          {
            path: '/sys/config/list',
            name: 'sysConfigList',
            component: systemConfig,
            meta: { permission: ['sys:config:list'] }
          },
          {
            path: '/channel/merchant/channel/list',
            name: 'channeList',
            component: channelList,
            meta: { permission: ['merchant:channel:list'] }
          },
          //商户银行通道列表
          {
          path: '/channel/merchant/bankchannel/list',
          name: 'bankchannel',
          component: () => import('@/components/bankchannelList/index.vue'),
          meta: { permission: ['merchant:bankchannel:list'] }
          },
          {
            path: '/channel/seeting/page',
            name: 'channelSetting',
            component: ChannelSetting,
            meta: { permission: ['channel:vendor:setting:list'] }
          },
          {
            path: '/systemmanagement/ipLogs',
            name: 'ipLogs',
            component: () => import('@/components/ipLogs/index.vue'),
            meta: { permission: ['ipLogs:manager'] }
          }
        ]
      },
      {
        path: '/devicesmanagement',
        name: 'devicesmanagement',
        component: RouteView,
        meta: {
          permission: ['devices:manager']
        },
        children: [
          {
            path: '/devices/money-history',
            name: 'money-history',
            component: () => import('@/components/device/money-history.vue'),
            meta: { permission: ['payout:money-history'] }
          },
          {
            path: '/admin/payout/bankInfo/list',
            name: 'payoutBankList',
            component: () => import('../components/payout/bankInfo/list'),
            meta: { permission: ['payout:bankInfo:list'] }
          },
          {
            path: '/admin/payout/history/list',
            name: 'payoutHistory',
            component: () => import('@/components/payout/history/list'),
            meta: { permission: ['payout:history:list'] }
          },
          {
            path: '/momoDevices/list/page',
            name: 'momoDevices',
            component: momoDevices,
            meta: { permission: ['device:momo:list'] }
          },
          {
            path: '/devices/histrans/momo/list',
            name: 'momohistory',
            component: momohistory,
            meta: {
              // permission: ['device:history:momo:list']
              isHide: false
            }
          },
          {
            //------------------momo-------
            path: '/devices/momo/withdraw',
            name: 'momowithdrawak',
            component: momowithdrawak,
            // component: () => import('@/components/device/money-history.vue'),
            meta: { permission: ['devices:momo:withdraw'], name: '0' }
          },
          {
            path: '/zaloDevices/list/page',
            name: 'zaloDevices',
            component: zaloDevices,
            meta: { permission: ['device:zalo:list'] }
          },
          {
            path: '/devices/histrans/zalo/list',
            name: 'zalohistory',
            component: zalohistory,
            meta: {
              // meta: { permission: ['device:history:zalo:list'] }
              isHide: false
            }
          },
          //------------------zalo-------
          {
            path: '/devices/zalo/withdraw',
            name: 'zalowithdrawak',
            component: zalowithdrawak,
            // component: () => import('@/components/device/money-history.vue'),

            meta: { permission: ['devices:zalo:withdraw'], name: '1' }
          },
          {
            path: '/viettelDevices/list/page',
            name: 'viettelDevices',
            component: viettelDevices,
            meta: { permission: ['device:viettel:list'] }
          },
          {
            path: '/devices/histrans/viettel/list',
            name: 'viettelhistory',
            component: viettelhistory,
            meta: {
              // meta: { permission: ['device:history:viettel:list'] }
              isHide: false
            }
          },
          {
            //------------------viettel-------
            path: '/devices/viettel/withdraw',
            name: 'viettelwithdrawak',
            component: viettelwithdrawak,
            // component: () => import('@/components/device/money-history.vue'),

            meta: { permission: ['devices:viettel:withdraw'], name: '2' }
          },
          {
            path: '/sys/pay/bank/list',
            name: 'paybank',
            component: paybank,
            meta: { permission: ['bank:account:list'] }
          },
          //自动收款银行账号
          {
            path: '/sys/auto/bank/list',
            name: 'paymentlist',
            component: () => import('@/components/autoPaymentlist/index.vue'),
            meta: { permission: ['auto:bank:account:list'] }
          },
          {
            path: '/sys/pay/bank/history/list',
            name: 'paybankhistory',
            component: paybankhistory,
            // component: () => import('@/components/device/money-history.vue'),

            meta: {
              meta: { permission: ['bank:history:list'] },
              isHide: false
              // name: '3'
            }
          },
          {
            path: '/sys/pay/bank/withdrawak/list',
            name: 'bankwithdrawak',
            component: bankwithdrawak,
            meta: { permission: ['sys:pay:bank:withdrawak:list'] }
          },
          {
            path: '/sys/pay/bank/withdrawak',
            name: 'bankconfirm',
            component: bankconfirm,
            meta: { permission: ['sys:pay:bank:withdrawak'] }
            // meta: { permission: ['device:history:viettel:list'] }
          }
        ]
      }
    ]
  },
  {
    path: '*',
    redirect: '/welcomes',
    hidden: true
  }
];
const constantRouterMap = [
  {
    name: 'user',
    path: '/user',
    redirect: '/user/login',
    component: RouteView,
    children: [
      {
        name: 'login',
        path: '/user/login',
        component: Login
      }
    ]
  },

  // {
  //   path: '/welcomes',
  //   component: C404
  // }
];

const router = new MyRouter({
  mode: 'history',
  routes: constantRouterMap
  // routes: asyncRouterMap
});

export { router as default, asyncRouterMap, constantRouterMap };



// WEBPACK FOOTER //
// ./src/router/index.js